import { useEffect, memo, useState } from "react";
import { Button, Flex, Space, Divider } from "antd";

import { BrowserRouter, useNavigate, useParams } from "react-router-dom";
import ItemService from "services/item";
import ItemEditor from "components/item/EditVariants"
import { useLoading } from "context/loading";
const itemService = new ItemService();

const ItemEditPage = () => {
    const navigate = useNavigate();
    const [item, setItem] = useState({});
    const [isLoading, setIsloading] = useState(true);
    let { id } = useParams();

    const loading = useLoading();

    useEffect(() => {
        loadItem();
    }, [id]);


    const loadItem = async () => {
        setIsloading(true);
        loading.showLoading();

        var data = await itemService.getByID(id);

        setItem(data);
        loading.dismissLoading();
        setIsloading(false);

    }





    return (
        <div>

            <ItemEditor data={item}></ItemEditor>
        </div>
    )
}




export default memo(ItemEditPage);